import { render } from "./user-popover.vue?vue&type=template&id=a21dfdbe&scoped=true"
import script from "./user-popover.vue?vue&type=script&lang=js"
export * from "./user-popover.vue?vue&type=script&lang=js"

import "./user-popover.vue?vue&type=style&index=0&id=a21dfdbe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21dfdbe"]])

export default __exports__